import { render } from "./Workshops.vue?vue&type=template&id=66aa3590"
import script from "./Workshops.vue?vue&type=script&lang=js"
export * from "./Workshops.vue?vue&type=script&lang=js"

import "./Workshops.vue?vue&type=style&index=0&id=66aa3590&lang=scss"

import exportComponent from "/builds/threatinformant/conference/exploit-marketing-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__